import React, { useState } from 'react'
import { ButtonWithIcon, InputBoxWraper } from '../../../constents/components';
import ctcIconSvg from '../../../Assets/svgs/ctcIcon.svg';

import { EDUCATION_LIST } from '../../../constants/list';


const Designation = ({ details, sendToNextStep, updateFunctions }) => {
    const [error, setError] = useState('');
    const [educationError, setEducationError] = useState('');
    const [isEducationDropdownOpen, setIsEducationDropdownOpen] = useState(false);

    const requirementSummary = 'A bit more about your professional life.';
    const placeholders = {
        designation: 'Your Current Designation',
        currentCtc: 'Current CTC',
        expectedCtc: 'Expected CTC'
    }
    const {updateEducation, updateDesignation, updateExpectedCTC, updateCurrentCTC, updateYearsOfExperience } = updateFunctions;

    const handleEducationChange = (value) => {
        updateEducation(value);

        if (value.trim()) {
            setEducationError('');
        }
    };

    const handleDesignationChange = (value) => {
        updateDesignation(value);
        if (value.trim()) {
            setError('');
        }
    };

    const educationValue = details.education || '';

        const filteredEducation = EDUCATION_LIST.filter((education) =>
            education.toLowerCase().includes(
                educationValue.toLowerCase()
            )
        );

        const isExactEducationMatch = EDUCATION_LIST.some(
            (education) =>
                education.toLowerCase() ===
                educationValue.trim().toLowerCase()
        );

    const validateAndContinue = () => {
    let isValid = true;

    if (!details.designation?.trim()) {
        setError('Please enter your current designation');
        isValid = false;
    }

    if (!details.education?.trim()) {
        setEducationError('Please enter your highest education');
        isValid = false;
    }

    if (!isValid) {
        return;
    }

    sendToNextStep();
};

    return (
        <div className='flex gap-2 flex-col w-full '>
            <div className='my-5 flex flex-col gap-3'>
                <p className=' font-semibold'>{requirementSummary}</p>

                {/* Education */}
                    <div className="relative">

                        <InputBoxWraper>

                            <input
                                type="text"
                                className="bg-transparent outline-none border-none w-full"
                                placeholder="Enter your highest education"
                                value={details.education || ""}
                                onFocus={() => {
                                    setIsEducationDropdownOpen(true);
                                }}
                                onChange={(e) => {
                                    handleEducationChange(e.target.value);
                                    setIsEducationDropdownOpen(true);
                                }}
                            />

                            {/* Dropdown Arrow */}
                            <button
                                type="button"
                                onMouseDown={(e) => {
                                    e.preventDefault();

                                    setIsEducationDropdownOpen(
                                        prev => !prev
                                    );
                                }}
                                className="flex items-center justify-center"
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`transition-transform duration-200 ${
                                        isEducationDropdownOpen
                                            ? "rotate-180"
                                            : ""
                                    }`}
                                >
                                    <path
                                        d="M7 10L12 15L17 10"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>

                        </InputBoxWraper>

                        {/* Education Dropdown */}
                        {isEducationDropdownOpen && (
                            <div className="absolute left-0 right-0 top-full z-50 mt-1 max-h-60 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">

                                {/* Listed Education Options */}
                                {filteredEducation.map((education) => (
                                    <button
                                        key={education}
                                        type="button"
                                        className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100"
                                        onMouseDown={(e) => {
                                            e.preventDefault();

                                            handleEducationChange(education);

                                            setIsEducationDropdownOpen(false);
                                        }}
                                    >
                                        {education}
                                    </button>
                                ))}

                                {/* Custom Education */}
                                {educationValue.trim() &&
                                    !isExactEducationMatch && (
                                        <button
                                            type="button"
                                            className="block w-full border-t border-gray-200 px-4 py-2 text-left text-sm font-medium hover:bg-gray-100"
                                            onMouseDown={(e) => {
                                                e.preventDefault();

                                                // Keep the user's custom education
                                                // instead of replacing it with "Other"
                                                handleEducationChange(
                                                    educationValue
                                                );

                                                setIsEducationDropdownOpen(false);
                                            }}
                                        >
                                            Other (enter your education)
                                        </button>
                                    )}

                            </div>
                        )}

                        {/* Validation */}
                        {educationError && (
                            <p className="text-sm text-red-500 mt-1">
                                {educationError}
                            </p>
                        )}

                    </div>

                <div>
                    <InputBoxWraper >
                        <input
                            type="text"
                            className='bg-transparent outline-none border-none w-full'
                            placeholder={placeholders.designation}
                            value={details.designation}
                            onChange={(e) => handleDesignationChange(e.target.value)}
                        />
                    </InputBoxWraper>
                    {error && (
                        <p className="text-sm text-red-500 mt-1">{error}</p>
                    )}
                </div>

                <div>

                    <InputBoxWraper>
                        <input
                            type="number"
                            min="0"
                            step="1"
                            className="bg-transparent outline-none border-none w-full"
                            placeholder="Enter years of experience"
                            value={
                                details.years_of_experience === 0
                                    ? ''
                                    : details.years_of_experience ?? ''
                            }
                            onChange={(e) => {
                                const value = e.target.value;

                                updateYearsOfExperience(
                                    value === '' ? 0 : Number(value)
                                );
                            }}
                        />
                    </InputBoxWraper>
                </div>
                <InputBoxWraper icon={ctcIconSvg} iconAltText='ctcIconSvg'>
                    <input
                        type="number"
                        className='bg-transparent outline-none border-none w-full'
                        placeholder={placeholders.currentCtc}
                        value={details.current_ctc ? details.current_ctc : ''}
                        onChange={(e) => updateCurrentCTC(e.target.value)}
                    />
                </InputBoxWraper>
                <hr />
                <InputBoxWraper icon={ctcIconSvg} iconAltText='ctcIconSvg'>
                    <input
                        type="number"
                        className='bg-transparent outline-none border-none w-full'
                        placeholder={placeholders.expectedCtc}
                        value={details.expected_ctc ? details.expected_ctc : ''}
                        onChange={(e) => updateExpectedCTC(e.target.value)}
                    />
                </InputBoxWraper>
            </div>

            <ButtonWithIcon 
                onButtonClick={validateAndContinue} 
                text="Continue" 
                classNames='p-4 text-white' 
                iconClassnames="rotate-180 h-4" 
            />
        </div>
    )
}

export default Designation;